import { render, staticRenderFns } from "./MiddleHome.vue?vue&type=template&id=25c547c4&scoped=true&"
import script from "./MiddleHome.vue?vue&type=script&lang=js&"
export * from "./MiddleHome.vue?vue&type=script&lang=js&"
import style0 from "./MiddleHome.vue?vue&type=style&index=0&id=25c547c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c547c4",
  null
  
)

export default component.exports